import { unstable_isUnrecognizedActionError } from 'next/navigation';

// True when a Server Action call failed because this browser tab runs an older (or newer)
// deployment than the server that answered, so the action ID is unknown there. Reloading the
// page fixes it. This is the only place that depends on the unstable Next.js API.
export function isStaleDeploymentError(error: unknown): boolean {
  return unstable_isUnrecognizedActionError(error);
}
